import axios from "axios";

export default async function fetchLanguageData() {
    const languageUrl = `${process.env.NEXT_PUBLIC_LANGUAGE_CDN}?q=${new Date().getTime()}`;
    let result = null;
    const res = await axios({
        method: "get",
        url: languageUrl,
    });
    if (res.status === 200) {
        result = res.data;
    }
    return result;
}
